import { render, staticRenderFns } from "./price-price-index.vue?vue&type=template&id=68c67377&scoped=true&"
import script from "./price-price-index.vue?vue&type=script&lang=js&"
export * from "./price-price-index.vue?vue&type=script&lang=js&"
import style0 from "./price-price-index.vue?vue&type=style&index=0&id=68c67377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c67377",
  null
  
)

export default component.exports